import React, { useEffect } from 'react';
import { Route, useHistory, Redirect } from 'react-router-dom';
import axios from 'axios';
import { getCompanyInfoFromStorage } from '../utils/kioskAuthMode';

function ProtectedRoutes(props) {
  const history = useHistory();
  const companyInfo = getCompanyInfoFromStorage();

  useEffect(() => {
    if (!companyInfo) {
      history.push('/login')
      return;
    }

    if (companyInfo.sessionId) {
      return;
    }

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${companyInfo.JWT_TOKEN}`,
      },
    };

    axios.get(`${process.env.REACT_APP_API_BACKEND}/api/kiosk/getSessionId`, config)
      .then((res) => {
        console.log(res.data);
        //add sessionId to companyInfo
        companyInfo.sessionId = res.data.kioskSessionId;
        localStorage.setItem('companyInfo', JSON.stringify(companyInfo));
      })
      .catch((err) => {
        console.log(err);
      });

  }, [companyInfo, history]);

  return companyInfo ? (
    <Route {...props} />
  ) : (
    <Redirect
      to="/login"
    />
  );
}

export default ProtectedRoutes;
